// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see AfterpayHubBrowseStartEvent
 */
export var AfterpayHubBrowseStart = function (_a) {
    var appLocation = _a.appLocation;
    return ({
        name: "AfterpayHub Browse Start",
        parameters: {
            cdf_entity: "AfterpayHub",
            cdf_action: "Browse",
            app_location: appLocation !== undefined && appLocation !== null ? appLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AfterpayHubBrowseViewAccountInformationSheetEvent
 */
export var AfterpayHubBrowseViewAccountInformationSheet = function (_a) {
    var info = _a.info;
    return ({
        name: "AfterpayHub Browse ViewAccountInformationSheet",
        parameters: {
            cdf_entity: "AfterpayHub",
            cdf_action: "Browse",
            info: info !== undefined && info !== null ? info.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AfterpayHubBrowseViewManageOrderInAfterpayHalfSheetEvent
 */
export var AfterpayHubBrowseViewManageOrderInAfterpayHalfSheet = function (_a) {
    var afterpayOrderId = _a.afterpayOrderId;
    return ({
        name: "AfterpayHub Browse ViewManageOrderInAfterpayHalfSheet",
        parameters: {
            cdf_entity: "AfterpayHub",
            cdf_action: "Browse",
            afterpay_order_id: afterpayOrderId !== undefined && afterpayOrderId !== null ? afterpayOrderId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AfterpayHubBrowseViewOrderDetailsEvent
 */
export var AfterpayHubBrowseViewOrderDetails = function (_a) {
    var afterpayOrderId = _a.afterpayOrderId;
    return ({
        name: "AfterpayHub Browse ViewOrderDetails",
        parameters: {
            cdf_entity: "AfterpayHub",
            cdf_action: "Browse",
            afterpay_order_id: afterpayOrderId !== undefined && afterpayOrderId !== null ? afterpayOrderId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AfterpayHubBrowseOpenPaymentDetailsEvent
 */
export var AfterpayHubBrowseOpenPaymentDetails = function (_a) {
    var afterpayOrderId = _a.afterpayOrderId, paymentStatus = _a.paymentStatus;
    return ({
        name: "AfterpayHub Browse OpenPaymentDetails",
        parameters: {
            cdf_entity: "AfterpayHub",
            cdf_action: "Browse",
            afterpay_order_id: afterpayOrderId !== undefined && afterpayOrderId !== null ? afterpayOrderId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_status: paymentStatus !== undefined && paymentStatus !== null ? paymentStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AfterpayHubBrowseOpenOverflowMenuEvent
 */
export var AfterpayHubBrowseOpenOverflowMenu = function (_a) {
    var afterpayOrderId = _a.afterpayOrderId;
    return ({
        name: "AfterpayHub Browse OpenOverflowMenu",
        parameters: {
            cdf_entity: "AfterpayHub",
            cdf_action: "Browse",
            afterpay_order_id: afterpayOrderId !== undefined && afterpayOrderId !== null ? afterpayOrderId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AfterpayHubBrowseViewMakePaymentOptionsEvent
 */
export var AfterpayHubBrowseViewMakePaymentOptions = function (_a) {
    var plasmaFlowToken = _a.plasmaFlowToken, afterpayOrderId = _a.afterpayOrderId, isOverdue = _a.isOverdue;
    return ({
        name: "AfterpayHub Browse ViewMakePaymentOptions",
        parameters: {
            cdf_entity: "AfterpayHub",
            cdf_action: "Browse",
            plasma_flow_token: plasmaFlowToken !== undefined && plasmaFlowToken !== null ? plasmaFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            afterpay_order_id: afterpayOrderId !== undefined && afterpayOrderId !== null ? afterpayOrderId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_overdue: isOverdue !== undefined && isOverdue !== null ? isOverdue.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AfterpayHubBrowseViewMakePaymentKeypadEvent
 */
export var AfterpayHubBrowseViewMakePaymentKeypad = function (_a) {
    var plasmaFlowToken = _a.plasmaFlowToken, afterpayOrderId = _a.afterpayOrderId;
    return ({
        name: "AfterpayHub Browse ViewMakePaymentKeypad",
        parameters: {
            cdf_entity: "AfterpayHub",
            cdf_action: "Browse",
            plasma_flow_token: plasmaFlowToken !== undefined && plasmaFlowToken !== null ? plasmaFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            afterpay_order_id: afterpayOrderId !== undefined && afterpayOrderId !== null ? afterpayOrderId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AfterpayHubBrowseChangeDateEvent
 */
export var AfterpayHubBrowseChangeDate = function (_a) {
    var plasmaFlowToken = _a.plasmaFlowToken, afterpayOrderId = _a.afterpayOrderId;
    return ({
        name: "AfterpayHub Browse ChangeDate",
        parameters: {
            cdf_entity: "AfterpayHub",
            cdf_action: "Browse",
            plasma_flow_token: plasmaFlowToken !== undefined && plasmaFlowToken !== null ? plasmaFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            afterpay_order_id: afterpayOrderId !== undefined && afterpayOrderId !== null ? afterpayOrderId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AfterpayHubManageMakePaymentEvent
 */
export var AfterpayHubManageMakePayment = function (_a) {
    var plasmaFlowToken = _a.plasmaFlowToken, afterpayOrderId = _a.afterpayOrderId, paymentType = _a.paymentType, amountCents = _a.amountCents, isSuccess = _a.isSuccess, failureReason = _a.failureReason, installmentSequence = _a.installmentSequence, numberTotalInstallments = _a.numberTotalInstallments;
    return ({
        name: "AfterpayHub Manage MakePayment",
        parameters: {
            cdf_entity: "AfterpayHub",
            cdf_action: "Manage",
            plasma_flow_token: plasmaFlowToken !== undefined && plasmaFlowToken !== null ? plasmaFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            afterpay_order_id: afterpayOrderId !== undefined && afterpayOrderId !== null ? afterpayOrderId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_type: paymentType !== undefined && paymentType !== null ? paymentType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount_cents: amountCents !== undefined && amountCents !== null ? amountCents.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_success: isSuccess !== undefined && isSuccess !== null ? isSuccess.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            failure_reason: failureReason !== undefined && failureReason !== null ? failureReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            installment_sequence: installmentSequence !== undefined && installmentSequence !== null ? installmentSequence.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            number_total_installments: numberTotalInstallments !== undefined && numberTotalInstallments !== null ? numberTotalInstallments.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AfterpayHubManageChangeDateEvent
 */
export var AfterpayHubManageChangeDate = function (_a) {
    var plasmaFlowToken = _a.plasmaFlowToken, afterpayOrderId = _a.afterpayOrderId, isSuccess = _a.isSuccess, selectedDate = _a.selectedDate, previousDate = _a.previousDate, failureReason = _a.failureReason;
    return ({
        name: "AfterpayHub Manage ChangeDate",
        parameters: {
            cdf_entity: "AfterpayHub",
            cdf_action: "Manage",
            plasma_flow_token: plasmaFlowToken !== undefined && plasmaFlowToken !== null ? plasmaFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            afterpay_order_id: afterpayOrderId !== undefined && afterpayOrderId !== null ? afterpayOrderId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_success: isSuccess !== undefined && isSuccess !== null ? isSuccess.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            selected_date: selectedDate !== undefined && selectedDate !== null ? selectedDate.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            previous_date: previousDate !== undefined && previousDate !== null ? previousDate.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            failure_reason: failureReason !== undefined && failureReason !== null ? failureReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
